/**
 * Tenant branding utilities.
 * Reads branding config from Tenant.ConfigurationJson — all keys are optional.
 * Malformed or missing JSON returns an empty object.
 *
 * Supported keys:
 *   bannerText   — text shown in the workspace banner strip
 *   accentColor  — CSS colour string for the banner background
 *
 * Note: the tenant logo is NOT here. It is a structured config key
 * (`branding.logo_url`), resolved server-side and delivered to the client as
 * `workspace.tenantLogoUrl` (spec: tenant-branding-identity).
 */

export interface TenantBranding {
  bannerText?: string;
  accentColor?: string;
}

export function parseTenantBranding(
  configurationJson: string | null | undefined
): TenantBranding {
  if (!configurationJson) return {};
  try {
    const parsed = JSON.parse(configurationJson);
    if (typeof parsed !== 'object' || parsed === null) return {};
    const branding: TenantBranding = {};
    if (typeof parsed.bannerText === 'string') branding.bannerText = parsed.bannerText;
    if (typeof parsed.accentColor === 'string') branding.accentColor = parsed.accentColor;
    return branding;
  } catch {
    return {};
  }
}
